import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import DomoticNavbar from '../Components/Navbar';
import "../Components/navbar.css";
import "./computo-videoconferencia.css";
import computo1 from "./img-domotic/PLAutomatizacion.png"


import microsoft from "./img-domotic/computoyvideoconfierencia.png"
import zoom from "./img-domotic/computoyvideoconfierencia.png"
import cisco from "./img-domotic/computoyvideoconfierencia.png"
import logitech from "./img-domotic/computoyvideoconfierencia.png"

const PLAutomatizacion = () => {
  const [showMenu, setShowMenu] = useState(false);

  // Datos específicos para Cómputo y Videoconferencia
  const imagenesGaleria = [
    { src: computo1, alt: "AUTOMATIZACIÓN ", caption: "Plataformas de automatización para tu empresa" },
    
  ];

  const servicios = [
  
  ];

  const tiposSoluciones = [
    {
      categoria: "Videoconferencia",
      items: [
        "Salas ejecutivas",
        "Sistemas todo-en-uno",
        "Soluciones para aulas",
        "Videowalls corporativos"
      ]
    },
    {
      categoria: "Equipamiento",
      items: [
        "Workstations gráficas",
        "Displays interactivos",
        "Sistemas de audio",
        "Control táctil"
      ]
    },
    {
      categoria: "Software",
      items: [
        "Plataformas colaborativas",
        "Gestión de dispositivos",
        "Analítica de reuniones",
        "Integración con UC"
      ]
    }
  ];

  const marcas = [
    { nombre: "Microsoft Teams", logo: microsoft },
    { nombre: "Zoom Rooms", logo: zoom },
    { nombre: "Cisco Webex", logo: cisco },
    { nombre: "Logitech", logo: logitech },
    { nombre: "Poly", logo: "/marcas/poly.png" },
    { nombre: "Crestron", logo: "/marcas/crestron.png" }
  ];

  // Efecto de scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.computo-scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="computo-container">
      <DomoticNavbar/>
      
      {/* Hero Section */}
      <section className="computo-hero">
        <div className="computo-hero-content">
          <h1 className="computo-hero-title">Plataformas de Automatización</h1>
          <p className="computo-hero-subtitle">
            Las mejores soluciones para el mejor rendimiento de tu empresa
          </p>
        </div>
      </section>

      {/* Galería de Imágenes */}
      <section className="computo-gallery computo-scroll-reveal">
        {imagenesGaleria.map((img, index) => (
          <div key={index} className="computo-gallery-item">
            <img 
              src={img.src} 
              alt={img.alt}
              className="computo-gallery-img"
            />
            <div className="computo-gallery-caption">
              <p>{img.caption}</p>
            </div>
          </div>
        ))}
      </section>


      
    {/* Sección de Características con Imágenes de Fondo */}
    <section className="ryn-features-section">
  <div className="ryn-features-container">
    <h2 className="ryn-features-title">Nuestras Plataformas de Automatización</h2>
    <p className="ryn-features-subtitle">Plataformas avanzadas para desempeños profesionales en tu empresa</p>
    
    <div className="ryn-features-grid">
      {/* Característica 1 */}
      <div className="ryn-feature-card">
        <div className="ryn-feature-content">
          <h3 className="ryn-feature-title">Plataformas de Automatización</h3>
          <ul className="ryn-feature-list">
            <li>Plataformas en sitio (On premise) o en la nube (SaaS) para automatización de procesos de atención al cliente a través de auto atención por omnicanalidad  mediante herramientas de IA (Inteligencia Artificial)</li>
            
          </ul>
        </div>
      </div>
      
   
    </div>
  </div>
</section>  



     

    </div>
  );
};

export default PLAutomatizacion;